import { useTranslation } from 'react-i18next';

/** An error whose user-facing message is a namespaced i18n key ("ns:key") with interpolation params. */
export class LocalizedError extends Error {
  readonly key: string;
  readonly params?: Record<string, unknown>;

  constructor(key: string, params?: Record<string, unknown>, options?: ErrorOptions) {
    super(key, options);
    this.name = 'LocalizedError';
    this.key = key;
    this.params = params;
  }
}

/** Returns a function giving the user-facing message of any thrown value. */
export function useErrorMessage() {
  const { t } = useTranslation();
  return (err: unknown): string => {
    if (err instanceof LocalizedError) return String(t(err.key as never, err.params as never));
    return err instanceof Error ? err.message : String(err);
  };
}
